import * as Yup from "yup";

const positive = (label) => Yup.number().typeError(`${label} must be a number`).required(`${label} is required`).moreThan(0, `${label} must be greater than 0`);
const whenReactive = (schema) => Yup.mixed().when("saleType", { is: "Reactive", then: () => schema, otherwise: (s) => s.notRequired() });
const whenFixed = (schema) => Yup.mixed().when("saleType", { is: "Fixed", then: () => schema, otherwise: (s) => s.notRequired() });

// Reactive lock tiers must start in order: trigger profit < tier 2 < tier 3 < max profit (same check as the API).
const SaleEngineSchema = Yup.object().shape({
  saleType: Yup.string()
    .oneOf(["Fixed", "Reactive"], "Sale type must be either 'Fixed' or 'Reactive'")
    .required("Sale type is required"),

  stopProfit: whenFixed(positive("Stop profit")),
  triggerProfit: whenReactive(positive("Trigger profit")),
  stopLoss: positive("Stop loss"),

  reactiveGap: whenReactive(positive("Trigger step")),
  breakevenFloor: whenReactive(Yup.number().typeError("Breakeven floor must be a number").required("Breakeven floor is required").min(0, "Breakeven floor must be 0 or more")),
  lockGap1: whenReactive(positive("Tier 1 lock gap")),
  lockGap2: whenReactive(positive("Tier 2 lock gap")),
  lockGap3: whenReactive(positive("Tier 3 lock gap")),
  lockGap4: whenReactive(positive("Lock gap")),
  lockTier2From: whenReactive(positive("Tier 2 from").moreThan(Yup.ref("triggerProfit"), "Must be above trigger profit")),
  lockTier3From: whenReactive(positive("Tier 3 from").moreThan(Yup.ref("lockTier2From"), "Must be above tier 2")),
  maxProfit: whenReactive(positive("Max profit").moreThan(Yup.ref("lockTier3From"), "Must be above tier 3")),
});

export default SaleEngineSchema;
